import React, { useContext, useEffect } from 'react'
import withStyles from '@mui/styles/withStyles'
import { Grid, Avatar, Typography } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import classNames from 'classnames'
import { isAdmin } from '../lib/userRoles'
import HomeCard from '../components/HomeCard'
import { AuthContext } from '../components/contexts/AuthContext'
import { CloudContext } from '../components/contexts/CloudContext'
import { applicationService, userService } from '../lib/services'
import { updateActAsData } from '../components/act-as/actions'

const style = theme => ({
    wrapper: {
        margin: 'auto',
        padding: '50px',
        width: '90%',
        maxWidth: '850px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    shortHeight: { paddingTop: '10px' },
    avatar: {
        height: '106px',
        width: '106px',
        fontSize: '48px',
        backgroundColor: theme.palette.primary.main,
    },
    welcomeText: {
        textAlign: 'center',
        padding: '20px 0 50px 0',
    },
})

const cardData = [
    {
        title: 'Make Tada yours',
        content: 'Configure your name, contact info and  password used in Tada applications.',
        footer: 'Manage your account',
        routePath: '/account',
    },
    {
        title: 'Your organization',
        content: 'Set up your team and manage their security restrictions.',
        footer: 'Manage your team',
        routePath: '/users',
        adminOnly: true,
    },
    {
        title: 'Tada Creators',
        content: 'Manage users to the Tada Tools.',
        footer: 'Manage Tada Creators',
        routePath: '/creators',
        superUserOnly: true,
    },
]

const Home = ({ classes, user }) => {
    const shortHeight = useMediaQuery('(max-height:850px)')
    const { setOUser, actAs, setActAs } = useContext(AuthContext)
    const { selectedCloud, setActAsCloud } = useContext(CloudContext)

    const cards = cardData.filter(
        card =>
            (card.adminOnly ? isAdmin(user, selectedCloud) : true) && (card.superUserOnly ? user.isCoreSuperUser : true)
    )

    useEffect(() => {
        if (!actAs) {
            checkActAs()
        }
    }, [])

    const checkActAs = async () => {
        const appResponse = await applicationService.getApplicationInfo(selectedCloud)
        const userResponse = await userService.getAccount()
        if (
            userResponse?.userInfo?.actingAs?.length > 0 &&
            userResponse?.userInfo?.actingAs[0]?.contextId == appResponse?.appId
        ) {
            const data = {
                userId: userResponse?.userInfo?.actingAs[0]?.userId,
                userName: '',
            }
            setActAs(data)
            setActAsCloud(selectedCloud)
            updateActAsData(setOUser)
        }
    }

    return (
        <div className={classNames(classes.wrapper, { [classes.shortHeight]: shortHeight })}>
            <Avatar className={classes.avatar}>{user.username[0]}</Avatar>

            <Typography variant="h4" className={classes.welcomeText}>
                Welcome, {user.username}
            </Typography>

            <Grid container spacing={4} justifyContent={cards.length === 1 ? 'center' : 'flex-start'}>
                {cards.map((card, index) => (
                    <Grid key={index} item sm={6} xs={12}>
                        <HomeCard {...card} />
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}

export default withStyles(style)(Home)
